module.exports = __webpack_public_path__ + "static/img/red_arrow.72ee80bd.jpg";